module.exports = __webpack_public_path__ + "assets/setting.27c79ef2.svg";